export enum GenitoreTrasmessoCittadinanaza {
  trasmissione1 = '1',
  trasmissione2 = '2',
  trasmissione3 = '3',
}
